import React from 'react'
import { Box, Typography } from '@mui/material'
import { useNamesTranslation } from '../hooks/useNamesTranslation'

const percent = (value) => `${Math.round(value * 100) / 100}%`

// One bar (maqueta `.mini-bar`): its intervals and the shaded band of the corrected stretch, by percentage of the bar.
// `data-left` / `data-width` carry the numbers so that a test can read them.
const Bar = ({ label, testId, spans, band }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: '54px minmax(0, 1fr)', gap: 0.75, alignItems: 'center' }}>
    <Typography variant='caption' color='text.secondary'>{label}</Typography>
    <Box data-testid={testId} sx={{ position: 'relative', height: 10, bgcolor: 'action.hover', borderRadius: '2px', overflow: 'hidden' }}>
      <i
        data-testid={`${testId}-band`} data-left={band.left} data-width={band.width}
        style={{ position: 'absolute', top: 0, bottom: 0, left: percent(band.left), width: percent(band.width), background: 'rgba(255, 143, 0, .28)' }}
      />
      {spans.map((span, index) => (
        <i
          key={index} data-testid={`${testId}-span`} data-left={span.left} data-width={span.width}
          style={{ position: 'absolute', top: 2, bottom: 2, left: percent(span.left), width: percent(span.width), background: '#1e88e5', borderRadius: '1px' }}
        />
      ))}
    </Box>
  </Box>
)

/**
 * The two mini bars of a row of the list (RN8): «Before» (what was recorded) and «After» (what was asked for, empty for a
 * void) on the same scale, with the corrected stretch shaded in both. `bars` is `miniBarsOf(...)`; nothing when it is not shown.
 */
const MiniBars = ({ bars }) => {
  const { t_ } = useNamesTranslation()
  if (!bars.shown) return null
  return (
    <Box data-testid='mini-bars' sx={{ display: 'grid', gap: 0.5, mt: 0.25 }}>
      <Bar label={t_('Before')} testId='mini-bar-before' spans={bars.before} band={bars.band} />
      <Bar label={t_('After')} testId='mini-bar-after' spans={bars.after} band={bars.band} />
    </Box>
  )
}

export default MiniBars
